import "../assets/css/profile-header.css";

function TabSectionHeader(props) {
    return (
        <div className="tab-section-header">
            <div className="section-name">
                <div className="title">{props.title}</div>
                <div className="subtitle">{props.subtitle}</div>
            </div>
        </div>
    );
}

export default TabSectionHeader;
